import MemberFormIcon from '@mui/icons-material/Description';
import MemberEmailIcon from '@mui/icons-material/Email';
import LinkIcon from '@mui/icons-material/Link';
import MemberTypesIcon from '@mui/icons-material/People';
import Box from '@mui/material/Box';

import { styles } from '../styles/stepIcons.styles';

const ICONS = {
	1: <LinkIcon />,
	2: <MemberTypesIcon />,
	3: <MemberFormIcon />,
	4: <MemberEmailIcon />,
	5: <MemberTypesIcon />
};

function StepIcons({ active, completed, icon }) {
	return (
		<Box
			sx={{
				...styles.root,
				...(active && styles.active),
				...(completed && styles.completed)
			}}
		>
			{ICONS[icon]}
		</Box>
	);
}

export default StepIcons;
